import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { MedicoCensuraPublicaRequest, MedicoCensuraPublicaResponse, MedicoCensuraPublicaUpdateRequest } from '@/core/api/sicom-api/registro/medico/medico.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class CensuraPublicaService extends BaseService {
    readonly PATH = `${SICOM_PATHS.registro.medico.base}/censuras-publicas`;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    private pessoaParams(params: Pessoa): HttpParams {
        return new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
    }

    listarCensurasPublicas(params: Pessoa, context?: HttpContext): Observable<MedicoCensuraPublicaResponse[]> {
        return this.http.get<MedicoCensuraPublicaResponse[]>(this.PATH, { params: this.pessoaParams(params), context });
    }

    inserirCensuraPublica(body: MedicoCensuraPublicaRequest, context?: HttpContext): Observable<MedicoCensuraPublicaResponse> {
        return this.http.post<MedicoCensuraPublicaResponse>(this.PATH, body, { context });
    }

    atualizarCensuraPublica(body: MedicoCensuraPublicaUpdateRequest, context?: HttpContext): Observable<MedicoCensuraPublicaResponse> {
        return this.http.put<MedicoCensuraPublicaResponse>(this.PATH, body, { context });
    }
}
